import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export const errorCode = (theme: ExactTheme) => css`
  font-size: 70px;
  line-height: 50px;
  font-weight: 600;
  color: ${theme.colorsV2.grey[900]};
`;

export const root = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
